// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1YRLx","placeholdersHeader":"styles_placeholdersHeader__g7-Vn","editorStyle":"styles_editorStyle__1nLR1","placeholdersBox":"styles_placeholdersBox__17FE_"};